import { render, staticRenderFns } from "./RequestActionModal.vue?vue&type=template&id=7126c5a2"
import script from "./RequestActionModal.vue?vue&type=script&lang=js"
export * from "./RequestActionModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports